"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translate_1 = require("utils/translate");
exports.default = (function () {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return (React.createElement(sok_ui_1.ToolsSidebar, { headerText: (0, translation_1.getLocalization)('admin/system/customerManagement/tools/') },
        React.createElement(react_router_dom_1.Link, { className: 'sok-tool-button green', to: "/".concat(selectedLanguage, "/admin/customermanagement/customer/create") },
            React.createElement("span", { className: 'sok-tool-button-icon' },
                React.createElement(Icon_1.Icon, { className: 'icofont-under-construction-alt' })),
            React.createElement("span", { className: 'sok-tool-button-text' }, (0, translation_1.getLocalization)('admin/system/customerManagement/tools/CreateNewCustomer')))));
});
